import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AuthService } from '../../../../../@core/auth/auth.service';
// Import the Cloudinary classes.
import { Cloudinary, CloudinaryImage } from '@cloudinary/url-gen';
import { thumbnail } from '@cloudinary/url-gen/actions/resize';
import { environment } from '../../../../../../environments/environment';


@Component({
  selector: 'kw-image',
  templateUrl: './kw-image.component.html',
  styleUrls: ['./kw-image.component.scss']
})
export class KwImageComponent implements OnInit, OnChanges {

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    let user = this.authService.getCurrentUser();
    let tenantId = user.tenant.tenantId;

    // Create a Cloudinary instance and set cloud name.
    const cld = new Cloudinary({
      cloud: {
        cloudName: environment.cloud_name,
      },
    });

    // Instantiate a CloudinaryImage object for the image with the public ID.
    this.public_id = cld.image(tenantId + '/' + this.imageId + '.png');
    this.createNgStyle();
    this.imageUrl = this.public_id.toURL();
  }

  @Input('imageId') imageId : string;

  @Input() imageWidth: number;

  @Input() imageHeight: number;

  public public_id: CloudinaryImage;

  public imageUrl: string;

  public fallbackUrl: string = 'assets/images/logo.png';

  public hasError: boolean = false;

  public ngStyleArray: any = {};

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit() {

  }

  onImageError() {
    this.hasError = true;
  }

  createNgStyle(){
    // Set width
    if(this.imageWidth !== null && this.imageWidth !== undefined){
      this.ngStyleArray.width = this.imageWidth;
      //Apply width
      this.public_id
      .resize(thumbnail().width(this.ngStyleArray.width));
    }

    // Set Height
    if(this.imageHeight !== null && this.imageHeight !== undefined){
      this.ngStyleArray.height = this.imageHeight;
      //Apply height
      this.public_id
      .resize(thumbnail().height(this.ngStyleArray.height));
    }

  }

}
